// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';
// import Alpine from 'alpinejs';

htmx.config.globalViewTransitions = true;

// window.Alpine = Alpine
// Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
    const b121ImageCarousel = document.querySelector('.splide.b121-image-carousel');
    if (b121ImageCarousel) {
      new Splide(b121ImageCarousel, {
          type: 'loop',
          rewind: true,
          height: '455px',
          autoWidth: true,
          arrows: false,
          pagination: false,
          autoplay: true,
          interval: 5000,
          focus: 'center',
      }).mount();
    }
});
